<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="3">
      <FilterSearch :fetchData="fetchPartners" />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="3">
      <FilterDates 
        :fetchData="fetchPartners" 
        :dateRange="true"
        :label="$t('partner.filter.date')"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="3">
      <FilterAutocomplete
        :label="$t('partner.filter.orderBy')"
        :fetchData="fetchPartners"
        :items="orderBy"
        type="orderBy"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FilterDates from '@/components/filters/FilterDates'
import FilterSearch from '@/components/filters/FilterSearch'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'

export default {
  name: 'PartnerListFilters',
  components: { 
    FilterDates,
    FilterAutocomplete,
    FilterSearch,
  },
  computed: {
    ...mapGetters(['isLoading']),
  },
  methods: {
    ...mapActions(['fetchPartners']),
  },
  data() {
    return {
      orderBy: [
        { value: 'ASC', name: this.$t('genericFilters.orderBy.ASC') },
        { value: 'DESC', name: this.$t('genericFilters.orderBy.DESC') },
      ]
    }
  },
}
</script>
